/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-06-25 00:25:19
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-06-26 22:48:36
 * @FilePath: \xm-runing-main\src\router\routes\modules\go-app-base.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {t} from "@/hooks/web/useI18n";

export default  [
  // {
  //   path: '/vue3Des/showPage/:pageCode',
  //   name: 'vue3Des',
  //   meta: {
  //     orderNo: 11,
  //     icon: 'ion:grid-outline',
  //     title: t('设计界面'),
  //   },
  //   component: () => import(/* webpackChunkName: "vue3Des" */'@/main-page/userDefPage.vue'),
  // },
  {
    path: '/xm-erp/xmFormConfig',
    name: 'xmFormConfig',
    meta: {
      orderNo: 8,
      icon: 'ion:grid-outline',
      title: t('开发态配置'),
    },
    component: () => import(/* webpackChunkName: "sysLog" */'@/views/xmFormConfig/index.vue'),
  },
  {
    path: '/xm-erp/xmRunningConfig',
    name: 'xmRunningConfig',
    meta: {
      orderNo: 8,
      icon: 'ion:grid-outline',
      title: t('运行态配置'),
    },
    component: () => import(/* webpackChunkName: "sysLog" */'@/views/xmRunningConfig/index.vue'),
  },
  {
    path: '/go-app-base/sysLog/sysLoginLog',
    name: 'sysLoginLog',
    meta: {
      orderNo: 8,
      icon: 'ion:grid-outline',
      title: t('系统登录日志'),
    },
    component: () => import(/* webpackChunkName: "sysLog" */'@/views/go-app-base/sysLoginLog/index.vue'),
  },
  {
    path: '/go-app-base/sysLog/applicationLog',
    name: 'applicationLog',
    meta: {
      orderNo: 9,
      icon: 'ion:grid-outline',
      title: t('系统应用日志'),
    },
    component: () => import(/* webpackChunkName: "sysLog" */'@/views/go-app-base/applicationLog/index.vue'),
  },
]
